import { makeAutoObservable } from 'mobx';
import QueryResponse from '../../../store/utils/query/QueryResponse';
import { copyToClipboard, downloadTextFile } from '../../../utils/browser';
import PulseKey, { PulseKeyDto } from './PulseKey';

const FIND_KEY_LIMIT = 1000;

export default class PulseKeys {
  readonly items: PulseKey[] = [];
  readonly hasMoreKeys: boolean = false;

  constructor(
    items: PulseKeyDto[],
    private response?: QueryResponse<PulseKeyDto>,
  ) {
    const privateOverrides = { toString: false };
    makeAutoObservable(this, { ...privateOverrides }, { autoBind: true });

    let itemsOnPage = items;
    if (items.length > FIND_KEY_LIMIT) {
      this.hasMoreKeys = true;
      itemsOnPage = items.slice(0, FIND_KEY_LIMIT);
    }

    this.items = itemsOnPage.map((dto) => new PulseKey(dto));
  }

  get selected(): PulseKey[] {
    return this.items.filter((key) => key.isSelected);
  }

  get isEmpty() {
    return this.items.length === 0;
  }

  exportAll() {
    const date = new Date().toISOString().slice(0, 10);
    downloadTextFile(this.toString(), `pulse-keys-${date}.txt`);
  }

  exportSelected() {
    const date = new Date().toISOString().slice(0, 10);
    downloadTextFile(this.toString(true), `pulse-keys-${date}.txt`);
  }

  async copyAllToClipboard() {
    copyToClipboard(this.toString());
  }

  toString(selectedOnly = false): string {
    const items = selectedOnly ? this.selected : this.items;
    return items.map((pulseKey) => pulseKey.key).join('\n');
  }
}
